const ATTRIBUTION_KEY = 'uroborox.analytics.valuation.v1';
const TTL = 24 * 60 * 60 * 1000;
export const VALUATION_EVENTS = [
  'valuation_started',
  'valuation_completed',
  'valuation_publish_clicked',
];

/** Explicit whitelist shared by signup, publication and valuation events. */
export const valuationAttribution = ({ origin, intent } = {}) =>
  origin === 'valorador' && ['seller', 'buyer'].includes(intent) ? { origin, intent } : {};

/** Attribute subsequent signup in this tab for 24 hours; never store financial answers. */
export const rememberValuationAttribution = intent => {
  const value = valuationAttribution({ origin: 'valorador', intent });
  if (!value.intent) return;
  try {
    sessionStorage.setItem(
      ATTRIBUTION_KEY,
      JSON.stringify({ ...value, expiresAt: Date.now() + TTL })
    );
  } catch (_) {
    // Analytics must not block the valuation when browser storage is unavailable.
  }
};

/** Consume only after successful signup, so a rejected signup can still be retried. */
export const consumeValuationAttribution = () => {
  try {
    const value = JSON.parse(sessionStorage.getItem(ATTRIBUTION_KEY) || 'null');
    sessionStorage.removeItem(ATTRIBUTION_KEY);
    return value?.expiresAt > Date.now() ? valuationAttribution(value) : {};
  } catch (_) {
    return {};
  }
};

/** Persist these markers with the draft; edits/resume do not count as a new valuation. */
export const valuationMilestone = (journey, event, intent) => {
  if (journey.example || !VALUATION_EVENTS.includes(event) || !['seller', 'buyer'].includes(intent))
    return null;
  if (!Array.isArray(journey.events)) journey.events = [];
  const key = `${event}:${intent}`;
  if (journey.events.includes(key)) return null;
  journey.events.push(key);
  return { event, intent };
};
